export default __webpack_public_path__ + "static/media/bakersIngredients.3b1db996.png";